import React from 'react';
import { connect } from 'react-redux';

import { Accordion } from 'apps/promo/components/common/accordion/Accordion';
import styles from 'apps/promo/components/common/accordion/Accordion.module.css';
import { PromoDangerouslyHtml } from 'apps/promo/components/common/promo-dangerously-html/PromoDangerouslyHtml';
import { PromoFlagIcon } from 'apps/promo/components/common/promo-flag-icon/PromoFlagIcon';
import { PromoPageContainer } from 'apps/promo/components/common/promo-page-container/PromoPageContainer';
import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';
import { PromoSectionContainer } from 'apps/promo/components/common/PromoSectionContainer';
import HeadingSection from 'apps/promo/components/common/sections/HeadingSection';
import { CommonSection, TextComponent } from 'apps/promo/components/common/sections/styles';
import NotAuthBasePage from 'apps/promo/components/NotAuthBasePage';
import { toLowerCase } from 'apps/promo/helpers/utils';
import type { RootState } from 'apps/promo/redux/store';

type Country = {
    code_a2?: string;
    name?: string;
    services_info?: string;
};

type Props = {
    helpSectionName?: string;
    helpSectionText?: string;
    countriesList?: Country[];
};

type StrapiApi = {
    title?: string;
    text?: string;
    countries?: Country[];
};

const SupportedCountriesPage = (props: Props) => {
    const getItems = () => {
        return (props.countriesList ?? []).map((c) => ({
            header: (
                <div className={styles.accordionHeaderContent}>
                    {c.code_a2 && (
                        <div className={styles.accordionFlag}>
                            <PromoFlagIcon name={`${toLowerCase(c.code_a2)}`} size={'24px'} />
                        </div>
                    )}
                    {c.name && (
                        <PromoText color={'baseColor'} tag={'span'}>
                            {c.name}
                        </PromoText>
                    )}
                </div>
            ),
            content: (
                <TextComponent>
                    <PromoDangerouslyHtml dangerouslyHtml={c.services_info} tag="div" color="baseColor" />
                </TextComponent>
            ),
        }));
    };

    return (
        <PromoPageContainer bgColor="eggshell03" hasTopPadding>
            <PromoSectionContainer>
                {props.helpSectionName && <HeadingSection title={props.helpSectionName} text={props.helpSectionText} titleTag={'h1'} />}
                {Array.isArray(props.countriesList) && (
                    <CommonSection>
                        <Accordion items={getItems()} />
                    </CommonSection>
                )}
            </PromoSectionContainer>
        </PromoPageContainer>
    );
};

const mapStateToProps = (state: RootState): Props => {
    const strapiApi = (state.extra as { strapiApi?: StrapiApi } | undefined)?.strapiApi;
    return {
        helpSectionName: strapiApi?.title,
        helpSectionText: strapiApi?.text,
        countriesList: strapiApi?.countries,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(SupportedCountriesPage));
